var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 289.48 289.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b4e4;}.cls-2{fill:#66d4ed;}.cls-3{fill:#fff;}.cls-4{fill:#87dfe6;}.cls-5{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.59px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 144.74,
    cy: 144.74,
    r: 144.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.69,124.18c-16.13,0-29.21-13.08-29.21-29.21s13.08-29.21,29.21-29.21l-.33-1.36c2.88-24.14,23.42-42.86,48.33-42.86,17.47,0,32.8,9.21,41.38,23.03l1.21,3.33c13.93,0,26.12,7.47,32.77,18.63l.17-.57c1.17-.14,2.35-.21,3.56-.21,16.13,0,29.21,13.08,29.21,29.21s-13.08,29.21-29.21,29.21h-127.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 73.27,
    y: 56.65,
    width: 115.25,
    height: 156.93,
    transform: "translate(-4.22 266.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.91 91.74 65.91 116.13 65.91 156.7 65.91 181.1 194.19 181.1 194.19 156.7 194.19 116.13 194.19 91.74 65.91 91.74"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 209.15,
    cy: 78.72,
    r: 63.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 78.91,
    y: 168.96,
    width: 33.3,
    height: 50.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 83.86,
    y: 173.32,
    width: 23.39,
    height: 31.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.55,
    cy: 211.77,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 230.13,
    cy: 207.82,
    r: 3.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 156.88,
    y: 160.74,
    width: 69.14,
    height: 94.15,
    transform: "translate(-16.36 399.27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157,
    y: 171.14,
    width: 57.96,
    height: 73.36,
    transform: "translate(-21.84 393.8) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesCircle);
export default __webpack_public_path__ + "static/media/devices_circle.f01088bb297997de38abd2d34233f099.svg";
export { ForwardRef as ReactComponent };